import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
  params={{
    particles: {
      number: {
        value: 80,
        density: {
          enable: false
        }
      },
      size: {
        value: {max: 0.99, min: 0.4}
      },
      line_linked: {
        enable: false,
      }
    },
    interactivity: {
      modes: {
        bubble: {
          distance: 250,
          duration: 2,
          size: 0,
          opacity: 0
        },
        repulse: {
          distance: 400,
          duration: 4
        }
      }
    }
  }}
  style={{
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: -1000000000
  }}
/>

  );
}

export default Particle;